
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/tutorial/manuals",
      function () {
        return require("private-next-pages/app/tutorial/manuals/index.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/tutorial/manuals"])
      });
    }
  